if (typeof debounce > "u") var debounce = function(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t), t = setTimeout(() => fn.apply(this, args), wait)
    }
};
if (!customElements.get("theme-header")) {
    class ThemeHeader extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.header_section = document.querySelector(".header-section"), this.menu = this.querySelector("#mobile-menu"), this.toggle = this.querySelector(".mobile-toggle-wrapper"), document.addEventListener("keyup", e => {
                e.code && e.code.toUpperCase() === "ESCAPE" && (this.toggle.removeAttribute("open"), this.toggle.classList.remove("active"))
            }), this.classList.contains("header-sticky--active") && document.body.classList.add("header-sticky--active"), this.toggle.querySelector(".mobile-toggle").addEventListener("click", e => {
                this.toggle.classList.contains("active") ? (e.preventDefault(), document.body.classList.remove("overflow-hidden"), this.toggle.classList.remove("active"), this.closeAnimation(this.toggle)) : (document.body.classList.add("overflow-hidden"), setTimeout(() => {
                    this.toggle.classList.add("active")
                }))
            }), window.addEventListener("scroll", this.setStickyClass.bind(this), {
                passive: !0
            }), window.addEventListener("scroll", this.setHeaderOffset.bind(this), {
                passive: !0
            }), window.addEventListener("scroll", this.setHeaderHeight.bind(this), {
                passive: !0
            }), window.dispatchEvent(new Event("scroll")), document.querySelector(".announcement-bar-section") && (window.addEventListener("scroll", this.setAnnouncementHeight(), {
                passive: !0
            }), window.dispatchEvent(new Event("resize"))), setTimeout(() => {
                this.mobile_nav = document.querySelector(".header-mobile-navigation"), this.mobile_nav && this.classList.contains("transparent--true") && this.mobile_nav.classList.add("is-fixed")
            }, 100), this.menu.querySelectorAll("summary").forEach(summary => summary.addEventListener("click", this.onSummaryClick.bind(this))), this.menu.querySelectorAll(".parent-link-back--button").forEach(button => button.addEventListener("click", this.onCloseButtonClick.bind(this)))
        }
        setStickyClass() {
            if (this.classList.contains("header-sticky--active")) {
                let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
                this.classList.toggle("is-sticky", window.scrollY >= offset && window.scrollY > 0)
            }
        }
        setAnnouncementHeight() {
            let h = document.querySelector(".announcement-bar-section").clientHeight;
            document.documentElement.style.setProperty("--announcement-height", h + "px")
        }
        setHeaderOffset() {
            let h = this.header_section.getBoundingClientRect().top;
            document.documentElement.style.setProperty("--header-offset", h + "px")
        }
        setHeaderHeight() {
            let h = this.clientHeight;
            document.documentElement.style.setProperty("--header-height", h + "px")
        }
        onSummaryClick(event) {
            const detailsElement = event.currentTarget.parentNode,
                parentMenuElement = detailsElement.closest(".link-container"),
                isOpen = detailsElement.hasAttribute("open");
            this.querySelector(".parent-link-back--button") && (this.menu.scrollTop = 0), setTimeout(() => {
                detailsElement.classList.add("menu-opening"), parentMenuElement && parentMenuElement.classList.add("submenu-open")
            }, 100)
        }
        onCloseButtonClick(event) {
            event.preventDefault();
            const detailsElement = event.currentTarget.closest("details");
            this.closeSubmenu(detailsElement)
        }
        closeSubmenu(detailsElement) {
            detailsElement.classList.remove("menu-opening"), this.closeAnimation(detailsElement)
        }
        closeAnimation(detailsElement) {
            let animationStart;
            const handleAnimation = time => {
                animationStart === void 0 && (animationStart = time), time - animationStart < 400 ? window.requestAnimationFrame(handleAnimation) : detailsElement.removeAttribute("open")
            };
            window.requestAnimationFrame(handleAnimation)
        }
    }
    customElements.define("theme-header", ThemeHeader)
}
if (!customElements.get("full-menu")) {
    class FullMenu extends HTMLElement {
        constructor() {
            super(), this.submenus = this.querySelectorAll(".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu")
        }
        connectedCallback() {
            if (!this.submenus.length) return;
            const _this = this;
            document.fonts.ready.then(function() {
                window.addEventListener("resize", debounce(function() {
                    _this.resizeSubMenus()
                }, 100))
            })
        }
        resizeSubMenus() {
            this.submenus.forEach(submenu => {
                submenu.querySelectorAll(":scope >.menu-item-has-children>.sub-menu").forEach(sub_submenu => {
                    let w = sub_submenu.offsetWidth,
                        l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth;
                    w + l > window.innerWidth ? sub_submenu.parentElement.classList.add("left-submenu") : sub_submenu.parentElement.classList.contains("left-submenu") && sub_submenu.parentElement.classList.remove("left-submenu")
                })
            })
        }
    }
    customElements.define("full-menu", FullMenu)
}
document.querySelector('.header__icon--search').addEventListener('click', function() {
  setTimeout(function() {
    document.getElementById('search-ai').focus();
  }, 100); // Slight delay to ensure modal is fully open before focusing
});